<template>
<!-- 来源类型templateType
园区活动(1)，物业报修(2)，会议预订(3)，意见反馈(4)，家政服务(5), 办公耗材(6)
evaluateType: 1 产品评价（非次彼即）2.服务评价；3.标签
evaluateGroup:服务：0，1，2，3，4，5
evaluateGroup:产品评价：0，1，2 -->
  <div class="container">
    <div class="evaluate_main" v-if="showPage">
      <!-- 满意不满意 -->
      <div class="common_modal" v-if="openProject != 0">
        <div class="common_title common_title_center">{{projectTitle}}</div>
        <div class="ext1_main_img">
          <div class="ext1_left" @click="changeEva(1)">
            <img class="face" v-if="satisfaction == 1" src="../../../assets/images/evaluate/bmy_ok.png" >
            <img class="face" v-else src="../../../assets/images/evaluate/bmy_default.png" >
            <div :class="[satisfaction == 1?'unlike':'']">不满意</div>
          </div>
          <div class="ext1_right" @click="changeEva(2)">
            <img class="face" v-if="satisfaction == 2" src="../../../assets/images/evaluate/my_ok.png">
            <img class="face" v-else src="../../../assets/images/evaluate/my_default.png">
            <div :class="[satisfaction == 2?'like':'']">满意</div>
          </div>
        </div>
        <div class="ext3">
          <div class="labelBoxArticle">
            <template v-for="(item,index) in detailsOutputList">
            <div class="labelBoxText" :class="[item.number ? 'labelBoxActive' : '']" @click="changeLabel(item.id)" :key="index" v-if="satisfaction != 0 && item.evaluateType === 3 && item.evaluateItemType == 1 && (item.evaluateGroup == satisfaction || item.evaluateGroup == 0)">
              <span>{{item.items}}</span></div>
            </template>
          </div>
        </div>
        <textarea v-if="openComment == 1" v-model="projectComment" class="textarea" maxlength="100" placeholder="请输入评价，不超过100个字" placeholder-class="textPlace" cursor-spacing='30'></textarea>
      </div>
      <!-- 服务评价 -->
      <div class="common_modal">
        <div class="common_title common_title_center">服务评价</div>
        <div class="ext2_main_list">
          <div v-for="(item,index) in starArr" :key="index">
            <img class="star_icon" v-if="serviceEvaluateStar > index" @click="changeStar(index)" src="../../../assets/images/evaluate/star_ok.png"/>
            <img class="star_icon" v-else @click="changeStar(index)" src="../../../assets/images/evaluate/star_default.png"/>
          </div>
        </div>
        <div class="fiveStari">{{serviceEvaluateStar|evaluateStatus}}</div>
        <div class="ext3">
          <div class="labelBoxArticle">
            <template v-for="(item,index) in detailsOutputList">
            <div :class="['labelBoxText', item.number ? 'labelBoxActive' : '']" @click="changeLabel(item.id)" :key="index" v-if="serviceEvaluateStar != 0 && item.evaluateType === 3 && item.evaluateItemType == 2 && (item.evaluateGroup == serviceEvaluateStar || item.evaluateGroup == 0)">
              <span>{{item.items}}</span>
            </div>
            </template>
          </div>
        </div>
        <textarea class="textarea" data-type="comment" placeholder="请输入评价，不超过100个字" maxlength="100" placeholder-class="textPlace" cursor-spacing='30' v-model="comment"></textarea>
      </div>

      <!--btn  -->
      <div class="footer button">
        <p class="submit btn_default" @click="submit" v-if="((openProject != 0 && satisfaction) || openProject == 0) && serviceEvaluateStar != 0">提交评价</p>
        <p v-else class="submit unclick">提交评价</p>
      </div>
  </div>

  </div>
</template>

<script>
import { getEvaluateTaskId, getEvaluateList , saveEvaluate, updateIntServOrder, callSpaceUp} from '../../../utils/api'
import util from "../../../utils/util";
import { mapState } from 'vuex';

export default {
  name:"evaluate",
  data () {
    return {
      templateType:'',
      beEvaluatedId:'',
      marketId:'',
      cityId:'',
      isclick:false,
      starArr:[1,2,3,4,5],
      projectComment:'',//活动产品评价
      serviceEvaluateStar:0,
      id:'',//当前评价id
      satisfaction: 0,//1不满意 2满意
      openProject:0,//产品评价是否开启（1开启）
      openComment: '', //1需要评语0不需要
      projectTitle:'',//标题
      comment:'',//评价内容
      detailsOutputList:'',
      userMess:{},
      showPage:false,
      orderId:''
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.common.userInfo,
      userId: state => state.common.userId,
      marketInfo: state => state.common.marketInfo,
      common:state => state.common
    })
  },
  filters:{
    evaluateStatus(status){
      switch (status) {
        case 1:
       return '非常差'
     case 2:
       return '差'
     case 3:
       return '一般'
     case 4:
       return '满意'
     case 5:
       return '非常满意'
     }
   }
  },
  created () {
    this.getEvaluateTaskId()
  },
  methods: {
      getEvaluateTaskId(){
        getEvaluateTaskId({id:this.$route.query.id}).then(res=>{
          console.log(res)
          this.showPage = true;
          if(res.res.code === 10000 && res.body){
            if(res.body.isEvaluate == '1'){
              // 物业报修,意见投诉,先跳转到评价成功页面(因后台暂时没有orderId,临时处理)
              if(res.body.templateType == '2' || res.body.templateType == '4'){
                this.$router.replace(`/evaluateSuccess?come=smEvaluate`)
              }else{
                this.$router.replace(`/evaluate/viewEvaluate?id=${res.body.orderId}`);
                return false;
              }
            }
            this.orderId = res.body.orderId
            this.userMess = res.body
            this.templateType = res.body.templateType
            this.referenceNo = res.body.taskNum
            this.referenceName = this.getName(this.templateType)
            this.getEvaluateList()
          }else{
            util.showToast(res.res.msg)
          }
        })
      },
      getName(val){
        // 园区活动(1)，物业报修(2)，会议预订(3)，意见反馈(4)，家政服务(5), 办公耗材(6)
        if(val == '1'){
          return '园区活动'
        }else if(val == '2'){
          return '物业报修'
        }else if(val == '3'){
          return '会议预订'
        }else if(val == '4'){
          return '意见反馈'
        }else if(val == '5'){
          return '家政服务'
        }else if(val == '6'){
          return '办公耗材'
        }
      },

      getEvaluateList() {
        getEvaluateList({
          templateType: this.templateType,
          marketId:this.userMess.marketId
        }).then(res => {
          if(res.res && res.res.code === 10000){
            console.log(res)
            let template = res.body.template;
            this.id = template.id,
            this.openComment = template.openComment,
            this.openProject = template.openProject,
            this.projectTitle = template.projectTitle,
            this.detailsOutputList = template.detailsOutputList
          }else{
            util.showToast(res.res.msg)
          }
        })
      },
      submit(){
        let templateList = [];
        let  detailsOutputList = this.detailsOutputList;
        //  设置产品评价satisfaction和服务评价的星星数量serviceEvaluateStar
        for (let item of detailsOutputList) {
          if (item.number !== 0) {
            templateList.push(item)
          } else if (item.evaluateType == 2 && item.evaluateItemType == 2 && this.serviceEvaluateStar != 0) {
            item.number = this.serviceEvaluateStar
            templateList.push(item)
          } else if (item.evaluateType == 1 && item.evaluateItemType == 1 && this.satisfaction != 0) {
            item.number = this.satisfaction
            templateList.push(item)
          }
        }
        let params = {
          evaluateTemplateId: this.id,
          beEvaluatedId:this.orderId,
          evaluateType: this.templateType,
          templateList:templateList,
          userName: this.userMess.userName,
          referenceNo:this.referenceNo,
          cityId:this.userMess.cityId,
          marketId:this.userMess.marketId,
          comment:this.comment
        }
        if (this.projectComment) {
          params.projectComment = this.projectComment
        }
        // 园区活动(1)，物业报修(2)，会议预订(3)，意见反馈(4)，家政服务(5), 办公耗材(6)
        switch (this.templateType) {
          case '2':
            // 提交人电话
            params.phone = this.userMess.phone
            // 维修工姓名
            params.target = this.userMess.target
            // 维修工电话
            params.targetPhone = this.userMess.targetPhone
            break;
          case '4':
            // 提交人电话
            params.phone = this.userMess.phone
            // 投诉人姓名
            params.target = this.userMess.target
            // 投诉人电话
            params.targetPhone = this.userMess.targetPhone
            break;
          default:
            params.referenceName = this.referenceName;
        }
        saveEvaluate(params).then(res => {
          if (res.res.code === 10000) {
            // 如果是投诉建议 则再调用spaceUp的 评价接口
            if(this.templateType == '4'){
                this.createEvaluateContent('TM')
            }
            // 如果是物业报修 则再调用spaceUp的 评价接口
            if(this.templateType == '2'){
              this.createEvaluateContent('FX')
            }
            // 如果是家政服务,修改家政服务订单状态
            if(this.templateType == '5'){
              this.updateIntServOrder('8')
            }
            // 物业报修,意见投诉,先跳转到评价成功页面(因后台暂时没有orderId,临时处理)
              if(this.templateType == '2' || this.templateType == '4'){
                this.$router.replace(`/evaluateSuccess?come=smEvaluate`)
              }else{
                util.showToast('评价成功');
                this.getEvaluateTaskId()
              }
          } else {
            util.showToast(res.res.msg)
          }
        })
      },
      createEvaluateContent(moduleCode){
        let parmes = {
          //	true	普通参数	int		公司id
          companyId:this.$route.query.myCompanyId || '',
          //true	普通参数	string		数据对象标识码,如投诉的:TM
          moduleCode:moduleCode,
          //true	普通参数	string		数据对象主键值，如投诉id,转成String类型
          target:this.userMess.target,
          //true	普通参数	string		评价人名称
          evaluatorName:this.userMess.userName,
          //true	普通参数	string		评价内容，后端可存储1000字
          evaluateContent:this.comment,
          url:'/property/rstRepair/createEvaluateContent'
        }
        callSpaceUp(parmes).then(res => {
          console.log(res);
        });
      },
      updateIntServOrder(status){
        let params = {
          id:this.$route.query.id,
          orderId:this.orderId,
          status:status,//取消
          imgs:[]
        }
        updateIntServOrder(params).then(()=>{
        })
      },//ext1
      changeEva(index){
          if(index == this.satisfaction){
            return false;
          }
          let detailsOutputList = this.detailsOutputList;
          for (let item of detailsOutputList) {
            if (item.evaluateType == 1 && item.evaluateItemType == 1) {
              item.number = 0
            }
          }
          this.detailsOutputList = detailsOutputList,
          this.satisfaction = index
      },
      //服务星个数
      changeStar(index){
          let detailsOutputList = this.detailsOutputList;
          for (let item of detailsOutputList) {
            if (item.evaluateType == 2 && item.evaluateItemType == 2) {
              item.number = 0
            }
          }
          this.serviceEvaluateStar = index+1,
          this.detailsOutputList = detailsOutputList
      },//ext3
      changeLabel(id) {
        let detailsOutputList = this.detailsOutputList;
        detailsOutputList.forEach(element => {
          if (element.id === id) {
            if (element.number == 0) {
              element.number = 1
            } else {
              element.number = 0
            }
          }
        });
        this.detailsOutputList = detailsOutputList
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../assets/css/common.less";
.common_modal{
  margin:20px;
  background:#fff;
  border-radius:16px;
  padding-bottom:28px;
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
}
.evaluate_main{
  margin-bottom:110px;
}
.evaluate_main_isIpx{
  margin-bottom:178px;
}
.ext1_main,.ext2_main,.ext4_main{
  padding:40px;
}
.common_title{
  font-size:28px;
  color:#333;
  line-height:40px;
  height:40px;
  display:block;
  width:100%;
  margin:40px 0;
  font-weight:500;
}
.common_title_center{
  text-align:center;
}
.ext1_main_img{
  display:flex;
  flex-direction:row;
  justify-content:center;
}
.ext1_main_img image{
  display:block;
  width:80px;
  height:80px;
  margin-bottom:20px;
}
.ext1_main_img text{
  color:#999;
  font-size:24px;
  line-height:34px;
}
.ext1_main_img .unlike{
  color:#FF7800;
}
.ext1_main_img .like{
  color:#FF7800;
}
.ext1_left,.ext1_right{
  width:240px;
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
}
.face{
  width: 80px;
  height: 80px;
  margin-bottom:20px;
}
/* ext2_main */
.ext2_main_list{
  display:flex;
  flex-direction:row;
  margin-bottom:28px;
}
.fiveStarLabel{
  font-size:28px;
  line-height:44px;
  color:#333;
  display:block;
  margin-right:20px;
  min-width:150px;
}
.star_icon{
  width:52px;
  height:52px;
  margin-right:24px;
  display:block;
}
.fiveStari{
  font-size:24px;
  color:#FF7800;
  line-height:44px;
}
/* ext3 */
.ext3{
  padding:40px 40px 28px;
}
.labelBoxArticle{
  display:flex;
  flex-direction:row;
  flex-wrap:wrap;
  justify-content:center;
  padding:2px;
}
.labelBoxText{
  padding:0 12px;
  height:48px;
  border-radius:4px;
  .border();
  height:48px;
  text-align:center;
  line-height:48px;
  display:block;
  color:#999;
  font-size:24px;
  margin:0 10px;
  margin-bottom:14px;
}
.labelBoxActive{
  border-color:rgba(23,64,218,1);
  color:#1740DA;
}
/* ext4 */
.textPlace{
  font-size:28px;
  color:#c9c9c9;
  line-height:40px;
}
.textarea{
  height:220px;
  width:100%;
  background:rgba(252,252,252,1);
  border-radius:4px;
  .border();
  font-size:28px;
  color:#333;
  line-height:40px;
  padding: 20px;
  box-sizing: border-box;
}
.footer{
  height:108px;
  position:fixed;
  bottom:0;left:0;right:0;
  background:#fff;
  display:flex;
  padding:0 28px;
  box-sizing: border-box;
  flex-direction:row;
  align-items:center;
  justify-content:center;
}
.isIpx{
  padding-bottom:68px;
}
.submit{
  display:block;
  width:100%;
  height:76px;
  border-radius:4px;
  text-align:center;
  line-height:76px;
  font-size:32px;
  color:#fff;
  background:rgba(23,64,218,1);
}
.unclick{
  color:#fff;
  background:rgba(218, 218, 218, 1);
}
</style>
